export default __webpack_public_path__ + "static/media/tanzanie.70cf44c1.png";